import point from "../point";
import line from "../line";
import config from "../../../store/sqftConfig";

export default function() {
  let points;
  if(config.measureUnit === "Metric" ) {
    points = [
      new point(0, -50, "lefttop"),
      new point(150, -50, "righttop"),
      new point(150, -26.38, "rightbottom"),
      new point(0, -26.38, "leftbottom")
    ];
  } else {
    points =  [
      new point(0, -50, "lefttop"),
      new point(150, -50, "righttop"),
      new point(150, -24, "rightbottom"),
      new point(0, -24, "leftbottom")
    ];
  }

  let lines = [
    new line(points[0], points[1]),
    new line(points[1], points[2]),
    new line(points[2], points[3]),
    new line(points[3], points[0])
  ];

  return lines;
}
